import {
  graphEndPadding,
  timeDividerWidth,
  xAxisHeight,
} from "../GraphContext"
import styles from "./NowLine.module.scss"
import {
  useDisplayTime,
  useThisMinute,
} from "src/hooks"

const strokeWidth = 1

export function NowLine() {
  const displayTime = useDisplayTime()
  const thisMinute = useThisMinute()

  const label = displayTime(thisMinute)

  return (
    <div
      className={styles.container}
      id="now-line"
      style={{
        right: graphEndPadding - (timeDividerWidth / 2),
        bottom: xAxisHeight,
        width: timeDividerWidth,
      }}
    >
      <svg
        className={styles.svg}
        xmlns="http://www.w3.org/2000/svg"
      >
        <line
          className={styles.line}
          strokeLinecap="round"
          strokeWidth={strokeWidth}
          x1={strokeWidth / 2}
          y1="0"
          x2={strokeWidth / 2}
          y2="100%"
        />
      </svg>
      <div
        className={styles.text}
        id="now-time-label"
      >
        {label}
      </div>
    </div>
  )
}
